import React from 'react';
import Icon from '@omilia/icon';
import styled from 'styled-components';

import LoadingBar from 'components/LoadingBar';
import { getThemeProp, theme } from 'theme';

const STitleContainer = styled.div`
  display: flex;
  align-items: center;

  > :first-child {
    margin-right: 12px;
  }
`;

const STitle = styled.span`
  height: 28px;
  color: ${getThemeProp('colors.fiordGrey')};
  font-size: 20px;
  line-height: 28px;
`;

const SMessage = styled.div`
  height: 40px;
  width: 480px;
  color: ${getThemeProp('colors.fiordGrey')};
  line-height: 20px;
`;

const getTrainModalContents = (
  modalIsOn: boolean,
  isTraining: boolean,
  isTrainingError: string,
  toggleModal: () => void,
) => {
  if (modalIsOn === false) {
    return { title: '', contents: '', primaryAction: null };
  }

  if (isTraining) {
    return {
      title: (
        <STitleContainer>
          <Icon glyph="ml-training" primaryColor={theme.colors.chetwodeBlue2} />
          <STitle>Training System</STitle>
        </STitleContainer>
      ),
      contents: (
        <div
          css={`
            width: 100%;
          `}
        >
          <SMessage>
            Your system is training through the machine learning model with data
            from training utterances you have set on each intent. Please wait…{' '}
          </SMessage>
          <LoadingBar
            color="blue"
            css={`
              display: block;
            `}
          />
        </div>
      ),
      primaryAction: null,
    };
  }

  if (isTrainingError) {
    return {
      title: (
        <STitleContainer>
          <Icon
            glyph="notification-warning"
            primaryColor={theme.colors.wildWatermelonRed}
          />
          <STitle>Ooops! Something went wrong.</STitle>
        </STitleContainer>
      ),
      contents: <SMessage>{isTrainingError}</SMessage>,
      primaryAction: {
        text: 'Close',
        onClick: toggleModal,
        contents: <div>Error</div>,
      },
    };
  }

  return {
    title: (
      <STitleContainer>
        <Icon
          glyph="notification-verify"
          primaryColor={theme.colors.alohaGreen}
        />
        <STitle>Training completed successfully!</STitle>
      </STitleContainer>
    ),
    contents: (
      <SMessage>
        Your system training through the machine learning model completed
        successfully!{' '}
      </SMessage>
    ),
    primaryAction: {
      text: 'Close',
      onClick: toggleModal,
      contents: <div>Success</div>,
    },
  };
};

export default getTrainModalContents;
